/**
 * 重复请求拦截器
 * - 调用此函数返回一个【函数A】，await【函数A】将拦截本次调用。
 * - 调用此函数入参：接受一个【函数B】，在【函数A】第一次被调用时触发【函数B】，【函数B】入参一为【拦截器】本身。
 * - 当在【函数B】中调用【拦截器】.reslot(value) 或者 【拦截器】.reject(value) 统一释放所有被拦截的promise并返回这个值
 */


// ======= 使用示例 =======
// const interceptedFun = repeatedlyPromiseInterceptor(
//    (interceptor, args) => {
//     await fetch()
//     return Promise.resolve(true)
//   },
//   { autoRelease: true }
// )

// checkCall 传入箭头函数时不支持改变this
export const repeatedlyPromiseInterceptor = (checkCall, { autoRelease = false } = {}) => {
  // 当前已经拦截的 promise请求队列
  const interceptedPromises = []
  // 这是一个拦截器函数，多次执行这个函数会被统一拦截到interceptedPromises
  const interceptor = function (...args) {
    // 如果当前没有已拦截的 promise，且 checkCall 存在，则执行 checkCall
    if (interceptedPromises.length === 0 && checkCall) {
      const fr = checkCall.apply(this, [interceptor, args])
      if (autoRelease && fr?.then) {
        fr.then(res => {
          passInterceptedPromises('resolve', res)
          return res
        }).catch(e => {
          passInterceptedPromises('reject', e)
          return e
        })
      } else if(autoRelease && !fr?.then) {
        throw new Error('[19270]: 无效的回调')
      }
    }
    // 返回一个新的 promise，进入拦截器队列
    return new Promise(async (resolve, reject) => {
      interceptedPromises.push({ resolve, reject })
    })
  }

  // 解析已拦截的 promise，并将解传递给析值它
  const passInterceptedPromises = (result, value) => {
    // 备份已拦截未解析 promise 队列
    const promises = interceptedPromises.splice(0)
    // 解析被备份的已拦截 promise 队列，并传递给它们
    promises.forEach((promise) => promise[result](value))
  }
  // 提供 resolve 和 reject 方法，用于解析已拦截的 promise
  interceptor.resolve = (value) => passInterceptedPromises('resolve', value)
  interceptor.reject = (reason) => passInterceptedPromises('reject', reason)
  // 追踪已拦截的 promise
  interceptor.interceptedPromises = interceptedPromises
  // 返回拦截器函数
  return interceptor
}


/**
 * 测试用例： 用于测试上面的函数的
 */
// {
//   const wait = (time) => new Promise((resolve) => setTimeout(resolve, time))

//   const checkCall = (interceptor, args) => {
//     console.log('Start Checking...')
//     wait(5000).then(() => {
//       console.log('Check Done')
//       // 解析已拦截的 promise
//       interceptor.resolve('OK')
//     })
//   }

//   const interceptor = repeatedlyPromiseInterceptor(checkCall)

//   // 第一个 promise 将被拦截，等待 5s 后解析
//   const promise1 = interceptor()

//   // 第二个 promise 将被拦截，等待 5s 后解析
//   const promise2 = interceptor()

//   // 链式调用多个 promise，只有第一个会被拦截
//   const promise3 = Promise.resolve().then(() => interceptor())
//     .then(() => interceptor())
//     .then(() => console.log('Chain DONE'))

//   Promise.all([promise1, promise2, promise3]).then((values) => {
//     console.log('All Promise Done:', values)
//   }).catch((error) => {
//     console.log('Promise Rejected:', error)
//   })

//   // functionTest()
// }